import { appendHeadersWithJSONContentType, customFetch } from 'utils/http';
import { UnexpectedError } from 'utils/errors';
import { M8UserProfileUpdate } from 'services/production/types';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  idUser: number;
  userProfileUpdate: M8UserProfileUpdate;
};

export const updateQuestionnaireInfo = async (params: Params) => {
  const { idUser, userProfileUpdate } = params;

  const body = JSON.stringify(userProfileUpdate);

  const headers = new Headers();

  appendHeadersWithJSONContentType(headers);

  const response = await customFetch(
    getM8AdminURL(`updateQuestionnaireInfo/${idUser}`),
    { method: 'POST', body, headers }
  );

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
